import React from 'react';
import HoldInventoryList from './HoldInventoryList';

const HoldInventory = () => {
  return (
    <div className="card shadow-lg main-card" style={{ position: 'relative' }}>
      <div className="card-header bg-secondary text-white">
        <h4 className="mb-0 h6 fw-semibold">{"Hold Summary"}</h4>
      </div>
      <div className="card-body">
        <HoldInventoryList />
      </div>
    </div>
  );
};

export default HoldInventory;
